import { useState, useEffect } from 'react';

import { activeRichMenu } from 'pages/lexusOfficialAccount/utils/LineLoginActions';
import useLineLiff from 'hooks/LineLiff';
import spinner from '../../assets/toyotaPremiun/spinner.svg';
import 'pages/toyotaPremiumOfficialAccount/toyota-premium-namespace.scss';

const ToyotaPremiumStartServicePage = () => {
  const [registered, setRegistered] = useState(false);

  const { liff, userInfo, errorMsg, setErrorMsg } = useLineLiff(
    process.env.REACT_APP_LIFF_ID_START
  );

  useEffect(() => {
    if (!userInfo) return;
    const idToken = liff.getIDToken();

    const activeRichMenuToService = async () => {
      try {
        const result = await activeRichMenu(idToken, {});
        if (!result.success) {
          setErrorMsg(result.message);
        } else {
          setRegistered(true);
          window.location.href = process.env.REACT_APP_LINE_OA_URL;
        }
      } catch (err) {
        setErrorMsg(
          `error occurred while fetching user details: ${err.message}`
        );
      }
    };

    activeRichMenuToService();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  return (
    <div className="toyota-premium-webview toyota-premium-webview--compact">
      <div className="start-service">
        <div className="start-service__status" role="status" aria-live="polite">
          {registered ? (
            <svg
              className="start-service__success-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 42 42"
              fill="none"
              aria-hidden="true">
              <circle
                cx="21"
                cy="21"
                r="20"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <path
                d="M13 21.5L18.5 27L29 15"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <div className="start-service__spinner" aria-hidden="true">
              <img className="start-service__spinner-img" src={spinner} alt="" />
            </div>
          )}
          <div className="start-service__copy">
            <h1 className="start-service__title">
              {registered ? '服務啟用成功' : '服務啟用中'}
            </h1>
            <p className="start-service__description">
              {registered
                ? '即將返回 TOYOTA PREMIUM'
                : '請稍候，正在為您啟用專屬服務'}
            </p>
            {errorMsg && <p className="start-service__error">{errorMsg}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToyotaPremiumStartServicePage;
